<template>
  <section>
    <div class="row">
      <div class="col title">Special Submissions</div>
      <!--Mobile Only-->
      <div class="col-3 pl-1 hidden-md-up">
        <for-authors-mobile-menu :anchors-list="anchorsList"></for-authors-mobile-menu>
      </div>
      <!--Mobile Only-->
    </div>
    <div>
      <p>
        1. Papers that were previously reviewed in a journal with a higher impact factor (e.g. Nature, Science, PNAS etc)
        may be submitted with previous peer-reviews (please revise and then format accordingly to {{siteName}} style).
        Submit all files on line as separate files. Previous peer-reviews will accelerate our decision. These papers
        will still be peer-reviewed in {{siteName}}.
      </p>
      <p>
        2. In exceptional cases members of the Editorial Boards may submit extraordinary papers after self-organized
        peer-review process (PNAS-like system), albeit it may be informal in some cases. Such papers will be additionally
        reviewed in {{siteName}}, in some cases verbally (e.g. telephone) or via email, to accelerate the decision.
        In some cases they will be additionally post-reviewed by the authors of Editorials. This system helps to accelerate
        decision on extraordinary papers.
      </p>
    </div>
  </section>
</template>

<script>
  import ForAuthorsMobileMenu from '@/components/for-authors/ForAuthorsPageMobileMenu'
  export default {
    name: 'for-authors-special-submission-content',
    components: {ForAuthorsMobileMenu},
    props: ['anchorsList'],
    data () {
      return {
        siteName: process.env.SITE_NAME
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ForAuthorsSpecialSubmissionContent.vue?056b08ec